import React, { Component } from 'react';
import {
    Edit,
    SimpleForm,
    BooleanInput,
    SelectInput,
    ReferenceInput,
} from 'react-admin';

// const required = (message = 'Required') =>
//     value => value ? undefined : message;

class PhecalcUserEdit extends Component {
    render() {
        return (
            <Edit {...this.props}>
                <SimpleForm redirect="/users">
                    <ReferenceInput label="Database" source="databaseId" reference="Phecalc/Databases">
                        <SelectInput optionText="name" optionValue="id" data-tip="description" />
                    </ReferenceInput>
                    <BooleanInput source="lVersion" label="L Database Version" />
                    <BooleanInput source="isAdmin" label="Admin" />
                    <BooleanInput source="single" label="Access to Single Section" />
                    <BooleanInput source="multi" label="Access to Multi Section" />
                    <BooleanInput source="quotation" label="Access to Quotation" />
                    <BooleanInput source="customer" label="Access to Customer" />
                    <BooleanInput source="multiRating" label="Access to Multi Section rating" />
                    <BooleanInput source="multiCip" label="Access to Multi Section CIP" />
                    <BooleanInput source="prices" label="Access to Price Lookup" />
                </SimpleForm>
            </Edit>
        );
    }
}

export default PhecalcUserEdit;